
import { Injectable, Inject, Injector, InjectionToken } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse,
    HttpHandler,
    HttpEvent
  } from '@angular/common/http';
  import { RoutingService } from './routing/services/routing.service';  
  
  import { Observable } from 'rxjs/Observable';
  import 'rxjs/add/operator/do';
  import 'rxjs/add/operator/catch';
  import 'rxjs/add/observable/throw';

  import { SettingsService } from './settings/services/settings.service';
  import { AppSettings } from './settings/app.settings';
  
  @Injectable()
  export class ApplicationHttpInterceptor implements HttpInterceptor {
    routingService: RoutingService;
    settingsService: SettingsService;
    appSettings: AppSettings;

    constructor(private inject: Injector) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {  
          
        this.routingService = this.inject.get(RoutingService);
        this.settingsService = this.inject.get(SettingsService);

        this.appSettings = this.inject.get(AppSettings);

        const requestTimeout = Number(request.headers.get('timeout')) || this.appSettings.longRunningRequestTimeout;

        return next.handle(request)
          .timeout(requestTimeout)
          .catch((err: HttpErrorResponse) => {  
          if (err.error instanceof Error) {
              // A client-side or network error occurred. Handle it accordingly.
              console.log('An error occurred:', err.error.message);
          }
          else if (err.name == 'TimeoutError') {
              console.log(`browser timed out ${request.url}`)

              var currentRoute = this.routingService.currentRoute();
              if (currentRoute==='/report/save'){
                console.log(this.routingService.currentRoute());  
                // A client-side or network error occurred. Handle it accordingly.
                this.routingService.routeToStatus();    
              }

              return Observable.empty();
          }
          else {
              // The backend returned an unsuccessful response code.
              console.log(`Backend returned code ${err.status}, body was: ${err.error}`);

              if (err.status === 408) {
                this.routingService.routeToStatus();
                return Observable.empty();
              }
          }

          return Observable.throw(new Error('Our custom error...'));
      });

    }
  }



// WEBPACK FOOTER //
// ./src/app/http.interceptor.ts